import { IFrontendBootResponseSchema } from "#/types/frontendboot.types";
import { IEnquiryResponseSchema } from "#/types/journey.types";
import { isCustomerFlow } from "#/utilities/flow.Utility";
import {
  useGetBrokerFrontendBootService,
  useGetEnquiryService,
  useGetJourneyFrontendBootService,
  useGetPartnerFrontendBootService,
} from "@repo/api-services/customer";
import { stringUtility } from "@repo/utilities/string.utility.ts";
import { urlUtility } from "@repo/utilities/url.utility.ts";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function useJourneyRequests() {
  const urlQueries = urlUtility.getUrlQueries(location.search);
  const navigate = useNavigate();
  const isPrefill = sessionStorage.getItem("is_prefilled") === "true";
  const prefilledEnquiryId = sessionStorage.getItem("prefilled_enquiry_id");

  const enquiryService = useGetEnquiryService({
    filters: {
      include:
        "shortListedQuote.plan.features,shortListedQuote.quotable.features,shortListedQuote.quotable.segment,shortListedQuote.quotable.covers,shortListedQuote.quotable.product.insurer,shortListedQuote.subjects",
      prefilled_enquiry_id: prefilledEnquiryId || "",
      is_prefilled: String(isPrefill),
    },
    enableQuery: !!urlQueries?.enq,
  });

  // Broker Frontend boot api call
  const brokerFrontendBoot = useGetBrokerFrontendBootService({
    enableQuery: isCustomerFlow(),
  });

  // Partner Frontend boot api call
  const partnerFrontendBootService = useGetPartnerFrontendBootService({});

  // Journey Frontend-boot api
  const journeyId =
    urlQueries?.journey_id || enquiryService?.data?.data?.journey?.id;
  const journeyFrontendBootService = useGetJourneyFrontendBootService({
    journeyId: String(journeyId) || "",
    enableQuery: !!journeyId,
  });

  useEffect(() => {
    if (journeyFrontendBootService?.status == "error") {
      navigate("*");
    }
  }, [journeyFrontendBootService?.status]);

  //VARIABLES
  const frontendBootData = journeyFrontendBootService?.data?.data as
    | IFrontendBootResponseSchema
    | undefined;

  const brokerFrontendBootData = brokerFrontendBoot?.data?.data;
  const enquiryData = enquiryService?.data?.data as
    | IEnquiryResponseSchema
    | undefined;
  const partnerFrontendBoot = partnerFrontendBootService?.data?.data;

  useEffect(() => {
    if (!brokerFrontendBootData) return;
    const theme = brokerFrontendBootData?.settings?.theme;

    if (theme) {
      const root = document.documentElement;
      root.style.setProperty(
        "--color-primary",
        stringUtility.hexToRgbUtility(theme?.primary_color)
      );
      root.style.setProperty(
        "--color-secondary",
        stringUtility.hexToRgbUtility(theme?.secondary_color)
      );
      root.style.setProperty(
        "--color-tertiary",
        stringUtility.hexToRgbUtility(theme?.tertiary_color)
      );
      root.style.setProperty(
        "--color-success",
        stringUtility.hexToRgbUtility(theme?.success_color)
      );
      root.style.setProperty(
        "--color-error",
        stringUtility.hexToRgbUtility(theme?.error_color)
      );
      root.style.setProperty(
        "--color-info",
        stringUtility.hexToRgbUtility(theme?.info_color)
      );
      root.style.setProperty(
        "--color-warning",
        stringUtility.hexToRgbUtility(theme?.warning_color)
      );
    }
  }, [brokerFrontendBootData]);

  return {
    urlQueries,
    enquiryData,
    frontendBootData,
    brokerFrontendBootData,
    partnerFrontendBoot,
    services: {
      journeyFrontendBootService,
      enquiryService,
      partnerFrontendBootService,
      brokerFrontendBoot,
    },
  };
}

export default useJourneyRequests;
